(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
(function () {
  function setupMobileBuyBar() {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.tmg-mobile-buybar')) return;

    var originalButton = document.querySelector('.product__block__buttons [data-add-to-cart]');
    if (!originalButton) return;

    var bar = document.createElement('div');
    bar.className = 'tmg-mobile-buybar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Acquisto rapido');
    bar.innerHTML =
      '<div class="tmg-mobile-buybar__inner">' +
        '<p class="tmg-mobile-buybar__promise">Spedizione 24–48h dalla partenza · Assistenza WhatsApp</p>' +
        '<button class="tmg-mobile-buybar__button" type="button"></button>' +
      '</div>';

    var stickyButton = bar.querySelector('.tmg-mobile-buybar__button');

    function syncButton() {
      var readyState = originalButton.querySelector('.btn-state-ready');
      var label = readyState ? readyState.textContent : originalButton.textContent;
      stickyButton.textContent = (label || 'Aggiungi al carrello').replace(/\s+/g, ' ').trim();
      stickyButton.disabled = originalButton.disabled;
      stickyButton.setAttribute(
        'aria-label',
        originalButton.getAttribute('aria-label') || 'Aggiungi al carrello'
      );
    }

    stickyButton.addEventListener('click', function () {
      if (!originalButton.disabled) originalButton.click();
    });

    document.body.appendChild(bar);
    syncButton();

    var observer = new IntersectionObserver(function (entries) {
      var shouldShow = !entries[0].isIntersecting;
      bar.classList.toggle('is-visible', shouldShow);
      document.body.classList.toggle('tmg-cro-buybar-visible', shouldShow);
    }, { threshold: 0.15 });

    observer.observe(originalButton);

    new MutationObserver(syncButton).observe(originalButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMobileBuyBar);
  } else {
    setupMobileBuyBar();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
